import {AdminUpdateSponsorForm} from './AdminUpdateSponsorForm';

export default AdminUpdateSponsorForm;
